import React, { useEffect, useState } from 'react';

// Keep the current photo's thumbnail visible until its larger image is decoded.
// Callers supply their own URLs so share/portal authorization stays intact.
export default function ProgressiveImage({ src, previewSrc, identity = src, active = true, onFullError, ...props }) {
  const [decoded, setDecoded] = useState(null);
  useEffect(() => {
    if (!active || !src) return;
    let cancelled = false;
    const probe = new Image();
    probe.decoding = 'async';
    probe.onload = async () => {
      try { await probe.decode(); } catch { /* onload confirmed usable bytes */ }
      if (!cancelled) setDecoded({ identity, src });
    };
    probe.onerror = () => { if (!cancelled) onFullError?.(); };
    probe.src = src;
    return () => { cancelled = true; };
  }, [src, identity, active]);

  const ready = active && decoded?.identity === identity && decoded?.src === src;
  return <img
    {...props}
    src={(ready ? src : previewSrc) || undefined}
    loading={active ? 'eager' : 'lazy'}
    decoding="async"
    data-full-ready={ready}
  />;
}
